import { render, staticRenderFns } from "./auth-role-modal.vue?vue&type=template&id=0223c3aa&scoped=true"
import script from "./auth-role-modal.vue?vue&type=script&lang=js"
export * from "./auth-role-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0223c3aa",
  null
  
)

export default component.exports